// extracted by mini-css-extract-plugin
export default {"wrapper":"mB-z","viewport":"nB-z","container":"oB-z","slide":"pB-z"};